import styled from 'styled-components'
import { Table as AntdTable } from 'antd'

// .ant-table-tbody > tr > td {
//     border-bottom: 1px solid #d4e8dc;
//     padding-top: 0px;
//     padding-bottom: 0px;
//     height: 40px;
//   }

export const StyledTable = styled(AntdTable)({
    overflowX: 'auto',
    '& .ant-table-thead > tr > th': {
        backgroundColor: '#009687',
        color: 'white !important',
    },
    '& .ant-pagination-item': {
        border: 'unset !important',
    },
    '& .ant-pagination-item-active': {
        borderColor: '#009687',
    },
    '& .ant-pagination-item-active a': {
        color: 'white !important',
    },
    '& .ant-pagination-item-link': {
        border: 'solid 0px !important',
    },
    ' & .ant-pagination-item-active': {
        backgroundColor: '#009687',
    },
    ' & .ant-table-thead > tr > th:hover': {
        backgroundColor: '#009687',
    },
}) as typeof AntdTable

export const StyledTableCompare = styled(AntdTable)({
    backgroundColor: 'white',
    '& table': {
        borderCollapse: 'collapse',
        border: '1px solid #D4E8DC',
    },
    '& thead > tr > th': {
        padding: '0px',
        borderRight: 'none !important',
    },
    '& thead > tr:first-child > th': {
        backgroundColor: '#093018 !important',
    },
    '& td:first-child': {
        backgroundColor: '#ffffff !important',
        // maxWidth: '300px',
        // minWidth: '300px',
        width: '300px !important',
        border: '1px solid #D4E8DC',
    },
    '& th:nth-child(even),td:nth-child(even)  ': {
        backgroundColor: '#f0f9f8',
        minWidth: '150px',
        width: '150px',
        border: '1px solid #D4E8DC',
    },
    '& td:nth-child(odd) ,th:nth-child(odd)': {
        backgroundColor: '#fefcf2',
        minWidth: '150px',
        width: '150px',
        border: '1px solid #D4E8DC',
    },
}) as typeof AntdTable

export const StyledTablePreviewReport = styled(AntdTable)({
    '& .ant-table-content': {
        border: 'none !important',
    },
    '& thead > tr > th': {
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
        fontWeight: 'bold',
    },
    '& table': {
        borderTop: 'none !important',
        borderRight: '2px solid black',
        borderBottom: '2px solid black',
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
    },
    '& th, td': {
        border: '2px solid black',
    },
    '& th:nth-child(1),th:nth-child(2)': {
        backgroundColor: '#d9d9d9 !important',
    },
    '& .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th': {
        borderBottom: 'none !important',
        borderRight: 'none !important',
    },

    '& thead > tr:nth-child(1)> th:nth-child(3)': {
        backgroundColor: '#f5d01a !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(1)> th:nth-child(4)': {
        backgroundColor: '#d4e8dc !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(1) ': {
        backgroundColor: '#f5d01a !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(2)': {
        backgroundColor: '#f5d01a !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(3) ': {
        backgroundColor: '#d4e8dc !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(4)': {
        backgroundColor: '#d4e8dc  !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& td:nth-child(3) ,td:nth-child(4)': {
        backgroundColor: '#fdf5cb',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& td:nth-child(5) ,td:nth-child(6)': {
        backgroundColor: '#f6fbf7',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& .ant-table-summary': {
        fontWeight: 'bold',
    },
    '& tr > td': {
        fontWeight: 600,
    },
    '& tr:last-child > td:nth-child(4)': {
        backgroundColor: '#f5d01a',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& tr:last-child > td:nth-child(6)': {
        backgroundColor: '#d4e8dc',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
}) as typeof AntdTable

export const StyledTablePreviewFullReport = styled(AntdTable)({
    '& .ant-table-content': {
        border: 'none !important',
    },
    '& thead > tr > th': {
        fontFamily: 'THSarabunNew',
        padding: '8px',
        fontSize: '20px',
        fontWeight: 'bold',
    },
    '& table': {
        borderTop: 'none !important',
        borderRight: '2px solid #e9e7e8',
        borderBottom: '2px solid #e9e7e8',
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
    },
    '& th, td': {
        border: '2px solid #e9e7e8',
    },
    '& th:nth-child(1),th:nth-child(2)': {
        backgroundColor: '#e9e7e8 !important',
    },
    '& .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th': {
        borderBottom: 'none !important',
        borderRight: 'none !important',
    },

    '& thead > tr:nth-child(1)> th:nth-child(3)': {
        backgroundColor: '#fced98 !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(1)> th:nth-child(4)': {
        backgroundColor: '#d4e8dc !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(1) ': {
        backgroundColor: '#fced98 !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(2)': {
        backgroundColor: '#fced98 !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(3) ': {
        backgroundColor: '#d4e8dc !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& thead > tr:nth-child(2)> th:nth-child(4)': {
        backgroundColor: '#d4e8dc  !important',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& td:nth-child(3) ,td:nth-child(4)': {
        backgroundColor: '#fffce9',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& td:nth-child(5) ,td:nth-child(6)': {
        backgroundColor: '#f6fbf7',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& .ant-table-summary': {
        //fontWeight: 'bold',
    },
    '& tr > td': {
        fontWeight: 600,
    },
    '& tr:last-child > td:nth-child(4)': {
        backgroundColor: '#fffce9',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
    '& tr:last-child > td:nth-child(6)': {
        backgroundColor: '#f6fbf7',
        borderRight: 'none !important',
        borderBottom: 'none !important',
    },
}) as typeof AntdTable

export const StyledOverviewTableRecommend = styled(AntdTable)({
    '& .ant-table-content': {
        border: 'none !important',
    },
    '& table': {
        borderTop: 'none !important',
        borderRight: '2px solid black',
        borderBottom: '2px solid black',
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
    },
    '& tr, td:first-child': {
        verticalAlign: 'top',
        width: '40% !important',
    },
    '& thead > tr > th, th:first-child': {
        verticalAlign: 'top',
        width: '40% !important',
    },
    '& tr, td:last-child': {
        width: '60% !important',
    },
    '& thead > tr > th, th:last-child': {
        width: '60% !important',
    },
    '& th, td': {
        border: '2px solid black',
    },
    '& thead > tr > th': {
        backgroundColor: '#d9d9d9 !important',
        borderBottom: 'none !important',
        borderRight: 'none !important',
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
        fontWeight: 'bold',
    },
    '& tr, td': {
        fontWeight: 600,
    },
}) as typeof AntdTable

export const StyledOverviewBoardsFullPreview = styled(AntdTable)({
    '& .ant-table-content': {
        border: 'none !important',
    },
    '& table': {
        fontFamily: 'THSarabunNew',
        fontSize: '20px',
    },
    '& thead > tr > th': {
        backgroundColor: '#EEF8F2 !important',
        fontWeight: 'bold',
    },
}) as typeof AntdTable
